/* BRINUTI – az új borítók első mockupján a feliratos réteg (számozott lépések
   és nyilak) cseréje a termékoldalon.

   MIÉRT KELL: a Teeinblue-s termékoldalon a galériát az app maga rajzolja
   újra a saját mockup-rétegeiből, a Shopify-ban tárolt képeket nem mutatja.
   A 12 legújabb borítón az első mockup egy általános „virágos” feliratos
   réteget használ (alcím, kedvenc ige, találomra mutató nyilak), ami azokon a
   borítókon nem stimmel. Amíg ez a réteg a Teeinblue-ban nincs kicserélve,
   itt cseréljük ki a böngészőben — a termék saját, helyes rétegére
   (assets/brinuti-mockup-<kód>.webp), a kicsinyített képét pedig a Shopify-ban
   már kijavított első képre.

   Csak ott fut, ahol a snippets/brinuti-mockup-javitas.liquid kiírja az
   adatot (#brinuti-mockup-adat); máshol semmit nem csinál. Ha a Teeinblue-ban
   a réteg ki lett cserélve, a régi réteg-fájl már nem jelenik meg, a script
   pedig nem talál mit cserélni — vagyis ártalmatlan, később is törölhető. */
(function () {
  var elem = document.getElementById('brinuti-mockup-adat');
  if (!elem) return;
  var adat;
  try { adat = JSON.parse(elem.textContent); } catch (e) { return; }
  if (!adat || !adat.reteg) return;

  /* A régi, általános feliratos réteg fájlneve (a Teeinblue CDN-jén). */
  var REGI = '261012_PzObsxzbegX025I6';
  var kep = adat.hash ? new RegExp('/campaign-products/\\d+/' + adat.hash + '(_thumbnail)?\\.webp') : null;

  function cserel(img) {
    var src = img.getAttribute('src') || '';
    if (!src) return;
    var uj = null;
    if (src.indexOf(REGI) > -1) {
      uj = adat.reteg;
    } else if (kep) {
      var t = kep.exec(src);
      if (t) uj = t[1] ? adat.kicsi : adat.nagy;
    }
    if (!uj || src === uj) return;
    img.removeAttribute('srcset');
    img.setAttribute('src', uj);
  }

  function atnez(csucs) {
    if (csucs.nodeType !== 1) return;
    if (csucs.tagName === 'IMG') cserel(csucs);
    var kepek = csucs.querySelectorAll ? csucs.querySelectorAll('img') : [];
    for (var i = 0; i < kepek.length; i++) cserel(kepek[i]);
  }

  atnez(document.documentElement);

  /* A Teeinblue többször is újrarajzolja a galériát (változat-, szín- és
     sablonváltáskor), ezért az oldal egész életében figyelünk. Csak az új
     elemeket és az img src-változásait nézzük, ez olcsó. */
  new MutationObserver(function (lista) {
    for (var i = 0; i < lista.length; i++) {
      var m = lista[i];
      if (m.type === 'attributes') cserel(m.target);
      else for (var j = 0; j < m.addedNodes.length; j++) atnez(m.addedNodes[j]);
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src']
  });
})();
